<template>
  <div class="import-main">
    <Space wrap>
    </Space>
    <div class="header_top">
      <div class="import_btn">
        导入
        <input type="file" accept=".xls,.xlsx" class="upload_file" @change="readExcel($event)" />
      </div>
    </div>
    <Table :columns="columns" :data="lists" height="500"></Table>
    <div class="submit_box">
      <Poptip confirm title="是否将数据导入列表中?" @on-ok="onClickSubmit" @on-cancel="cancel">
        <Button type="success">提交数据</Button>
      </Poptip>
    </div>
    <br />
    <br />
  </div>
</template>

<script>
import XLSX from "xlsx";

export default {
  name: "",
  components: {
  },
  props: {
    refListTable: {
      type: Function,
    },
  },
  data() {
    return {
      columns: [
        {
          title: '序号',
          key: 'no',
          minWidth: 80,
          align: 'left',
          copy: true,
        },
        {
          title: "供应商",
          key: "supplierName",
          width: 180,
          align: "left",
        },
        {
          title: "地址",
          width: 180,
          align: "left",
          key: "supplierAddress",
        },
        {
          title: "状态",
          key: "state",
          minWidth: 120,
          align: "center",
          render: (h, params) => {
            const text = (params.row.state == 1
              ? "提需求"
              : params.row.state == 2
                ? "需求沟通"
                : params.row.state == 3
                  ? "正式立项"
                  : params.row.state == 4
                    ? "预算申报"
                    : params.row.state == 5
                      ? "上会通过"
                      : params.row.state == 6
                        ? "院内谈判"
                        : params.row.state == 7
                          ? "公开调研"
                          : params.row.state == 8
                            ? "招投标"
                            : params.row.state == 9
                              ? "签订合同"
                              : params.row.state == 10
                                ? "服务中"
                                : params.row.state == 11
                                  ? "lost"
                                  : params.row.state == 12
                                    ? "潜在"
                                    : "");

            return <span>{text}</span>

          }
        },
        {
          title: "性质",
          key: "supplierNature",
          minWidth: 120,
          align: "center",
          render: (h, params) => {
            const text = params.row.supplierNature == 1 ? "厂家" : params.row.supplierNature == 2 ? "代理" : ""
            return <span>{text}</span>
          }
        },
        {
          title: "法人代表",
          key: "legalRepresentative",
          minWidth: 120,
          align: "center",
        },
        {
          title: "联系电话",
          key: "phone",
          minWidth: 120,
          align: "center",
        },
        {
          title: "注册资金(万元)",
          key: "registeredCapital",
          minWidth: 120,
          align: "center",
        },
        {
          title: "供应商规模",
          key: "supplierScale",
          minWidth: 120,
          align: "center",
        },
        {
          title: "项目经理",
          key: "projectManager",
          minWidth: 120,
          align: "center",
        },
        {
          title: "项目经理电话",
          key: "telephone",
          minWidth: 120,
          align: "center",
        },
        {
          title: "驻场人员",
          key: "userName",
          minWidth: 120,
          align: "center",
        },
        {
          title: "综合评分",
          key: "comprehensiveServiceRating",
          minWidth: 120,
          align: "center",
        },
        {
          title: "备注",
          key: "remark",
          minWidth: 120,
          align: "center",
        },
      ],
      lists: [],
      oldList: [],
    };
  },
  computed: {},
  created() {
  },
  methods: {
    readExcel(e) {
      // 读取表格文件
      let that = this;
      const files = e.target.files;
      if (files.length <= 0) {
        return false;
      } else if (!/.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.$message({
          message: "上传格式不正确，请上传xls或者xlsx格式",
          type: "warning",
        });
        return false;
      } else {
        // 更新获取文件名
        that.upload_file = files[0].name;
      }
      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: "binary",
          });
          const wsname = workbook.SheetNames[0]; //取第一张表
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]) || []; //生成json表格内容
          that.lists = [];
          // 从解析出来的数据中提取相应的数据
          ws.forEach((item) => {
            //否则直接返回
            console.log(item);

            that.lists.push({
              no: item["__rowNum__"],
              supplierName: item["供应商"],
              supplierAddress: item["地址"],
              state: item["状态"],
              supplierNature: item["性质"],
              legalRepresentative: item["法人代表"],
              phone: item["联系电话"],
              registeredCapital: item["注册资金(万元)"],
              supplierScale: item["供应商规模"],
              projectManager: item["项目经理"],
              telephone: item["项目经理电话"],
              userName: item["驻场人员"],
              comprehensiveServiceRating: item["综合评分"],
              remark: item["备注"],
            });
            console.log(that.lists,'0000');
          });
          // 给后端发请求
        } catch (e) {
          return false;
        }
      };
      fileReader.readAsBinaryString(files[0]);
      e.target.value = "";
    },
    onClickSubmit() {
      if (this.lists.length == 0) {
        this.$Modal.remove();
        return;
      }
      this.$Spin.show(
        {
          render: (h) => {
            return h('div', [
              h('Icon', {
                'class': 'demo-spin-icon-load',
                "style": "animation: ani-demo-spin 1s linear infinite",
                props: {
                  type: 'ios-loading',
                  size: 18
                }
              }),
              h('div', 'Loading')
            ])
          }
        });
      $utils.api
        .load(`/admin/system/procurementSupplier/listModel`, this.lists, "POST")
        .then((res) => {
          if (res.code == 200) {
            this.lists = res.data || [];
            this.oldList = res.data || [];
            let arr = res.successTotal || 0;
            $utils.toast.success(`导入成功`);
            this.refListTable();
            this.$Spin.hide()
            this.$Modal.remove();
          }
          if (res.code == 500) {
            this.lists = res.data || [];
            this.oldList = res.data || [];
            this.$Spin.hide()
          }
        })
        .catch((e) => {
          this.$Spin.hide()
          $utils.toast.error("导入异常" + e.message);
        });
    },
  },
};
</script>
<style lang="less" scoped>
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.header_top {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 20px;
}

.import_btn {
  width: 60px;
  height: 35px;
  border-radius: 10px;
  background-color: #fb9338;
  text-align: center;
  line-height: 35px;
  position: relative;
  color: #fff;

  .upload_file {
    opacity: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 100;
  }
}

.submit_box {
  // width: 100px;
  float: right;
  margin-top: 20px;
  margin-left: 15px;
}
</style>
